import React, { Dispatch, SetStateAction } from "react";
import styled from "@emotion/styled";
import { Drawer } from "antd";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
const DrawerContainer = styled(Drawer)(({ theme }) => ({
  borderRadius: "10px 10px 0 0",
  fontFamily: "Pretendard ,Sans-serif",

  ".ant-drawer-header": {
    display: "flex",
    borderBottom: "none",
  },

  ".ant-drawer-title": {
    display: "flex",
    justifyContent: "center",
  },

  ".ant-drawer-body": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "0 0 4.8rem",
    maxHeight: "70vh",

    "::-webkit-scrollbar": {
      display: "none",
    },
  },
}));

const ContentWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "space-between",
  gap: "1.6rem",
  color: theme.color.black,
  fontSize: "1.6rem",
  lineHeight: "2.4rem",
  padding: "0 2rem",
}));

const TitleWrapper = styled.div(({ theme }) => ({
  width: "100%",
  position: "relative",
  display: "flex",
  justifyContent: "center",
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.medium,
  lineHeight: "2rem",
}));

const CloseButton = styled.button(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: 0,
}));

type Props = {
  children: React.ReactNode;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  title: string;
  closeIcon?: boolean;
};
const TitleDrawer = ({
  children,
  open,
  setOpen,
  title,
  closeIcon = false,
}: Props) => {
  const theme = useTheme();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <DrawerContainer
      zIndex={10000}
      title={
        <TitleWrapper>
          <span>{title}</span>

          {closeIcon && (
            <CloseButton onClick={handleClose}>
              <Image src={theme.image.close.default} />
            </CloseButton>
          )}
        </TitleWrapper>
      }
      closable={false}
      height="auto"
      placement="bottom"
      onClose={handleClose}
      open={open}>
      <ContentWrapper>{children}</ContentWrapper>
    </DrawerContainer>
  );
};

export default TitleDrawer;
